import React from 'react';
import { CheckoutPage } from './components/CheckoutPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full min-h-screen bg-[#0a0a0a]" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CheckoutPage data-id="element-2" />
    </div>;
}